import { LocaleText } from './locales'

export type QuestionsFormData = {
    [key: string]: string | string[] | null | undefined
}

export enum QuestionTypes {
    FILL_IN_THE_BLANKS = 'FillInTheBlanks',
    INLINE_RADIO = 'InlineRadio',
    RADIO = 'Radio',
    INLINE_CHECKBOX = 'InlineCheckbox',
    CHECKBOX = 'Checkbox',
}

export enum AnswerResults {
    EXTEND_QUESTION_TEXT = 'ExtendQuestionText',
    SHOW_NEXT_QUESTION = 'ShowNextQuestion',
    ENDPOINT_ALLOW_REGISTRATION = 'EndpointAllowRegistration',
    ENDPOINT_NO_REGISTRATION = 'EndpointNoRegistration',
}

export enum QuestionNotificationTypes {
    SUCCESS = 'Success',
    WARNING = 'Warning',
}

export enum DepartmentType {
    OPERATIONS = 'operations',
    PRODUCER_SERVICES = 'producer services',
}

export type AnswerResultEndpointNotification = {
    type: QuestionNotificationTypes
    text: LocaleText
    additionalInformation?: AdditionalInformation
}

type AnswerResult = {
    type: AnswerResults
    target: QuestionId | null
    endpointNotification?: AnswerResultEndpointNotification
    registrationKey?: string
    nonContractRegistrationKey?: string
    departmentType?: DepartmentType
}

export interface Answer {
    id: string
    text: LocaleText
    result: AnswerResult
}

export interface Endpoint extends Answer {
    endpointKey: string
    startDate: Date
    departmentType?: DepartmentType
}

type QuestionContent = {
    text: LocaleText
    answers: Answer[]
}

type AdditionalInformation = {
    title: LocaleText
    description: LocaleText
}

export type QuestionId = string

export type Question = {
    id: QuestionId
    questionContent: QuestionContent
    questionType: QuestionTypes
    additionalInformation?: AdditionalInformation
}
